const OPEN_SPINNER = 'OPEN_SPINNER'
const CLOSE_SPINNER = 'CLOSE_SPINNER'

export const openSpinnerAction = () => ({ type: OPEN_SPINNER })
export const closeSpinnerAction = () => ({ type: CLOSE_SPINNER })

export default function openSpinnerReducer(state = { open: false }, { type }) {
   switch (type) {
      case OPEN_SPINNER:
         return {
            open: true
         }
      case CLOSE_SPINNER:
         return {
            open: false
         }
      default:
         return state
   }
}
